import React, { useContext } from 'react'
import Inline from '@/component/Primitive/Inline'
import ButtonStandard from '@/component/Primitive/ButtonStandard'
import Spacer from '@/component/Primitive/Spacer'
import { SignUpContext } from '@/component/Context/SignUpContext'

const AboutCtaWidget = () => {
  const { handleModalVisibility } = useContext(SignUpContext)
  const handleModalOpen = () => {
    handleModalVisibility(true)
    document.body.classList.add('has-locked-scrolling')
  }
  return (
    <Spacer mt={8}>
      <Inline center>
        <ButtonStandard to="/section" as="/advertise" primary>
          Advertise with us
        </ButtonStandard>
        <ButtonStandard onClick={handleModalOpen} outline primary inverse>
          Join our community
        </ButtonStandard>
      </Inline>
    </Spacer>
  )
}

export default AboutCtaWidget
